/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Reason_Signupbonus1Inputs */

const zh_usage_reason_signupbonus1 = /** @type {(inputs: Usage_Reason_Signupbonus1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注册赠送`)
};

const en_usage_reason_signupbonus1 = /** @type {(inputs: Usage_Reason_Signupbonus1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-up bonus`)
};

const es_usage_reason_signupbonus1 = /** @type {(inputs: Usage_Reason_Signupbonus1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonificación de registro`)
};

/**
* | output |
* | --- |
* | "Sign-up bonus" |
*
* @param {Usage_Reason_Signupbonus1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const usage_reason_signupbonus1 = /** @type {((inputs?: Usage_Reason_Signupbonus1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Reason_Signupbonus1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_usage_reason_signupbonus1(inputs)
	if (locale === "en") return en_usage_reason_signupbonus1(inputs)
	return es_usage_reason_signupbonus1(inputs)
});
export { usage_reason_signupbonus1 as "usage_reason_signupBonus" }